import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import machines from '../assets/icons/Machines-Installed.png';
import years from '../assets/icons/Year-of-experiance.png';
import cuttingedge from '../assets/icons/Cutting-Edge-Technologies.png';
import happydoctors from '../assets/icons/Happy-Doctors.png';

gsap.registerPlugin(ScrollTrigger);

const ChooseUs = () => {
  const cardsRef = useRef([]);

  useEffect(() => {
   
    gsap.fromTo(
      cardsRef.current,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.3,
        ease: "power3.out",
        scrollTrigger: {
          trigger: cardsRef.current,
          start: "top 80%", 
          end: "bottom 20%", 
          toggleActions: "play none none none",
        },
      }
    );
  }, []);

  return (
    <>
      <div className="container mx-auto px-4 py-12 lg:grid lg:grid-cols-4 lg:gap-16 xl:gap-24 lg:py-24 lg:px-6 items-center">
        <div className="col-span-2 mb-8">
          <p className="text-6xl font-extrabold text-gradient bg-clip-text text-transparent bg-gradient-to-r bg-colorPrimary">Why Choose Us</p>
          <h2 className="mt-4 text-2xl font-bold tracking-tight text-gray-800">Trusted by over 600 million users and 10,000 teams</h2>
          <p className="font-light text-lg text-gray-600 mt-2">
            Our rigorous security and compliance standards are at the heart of all we do. We work tirelessly to protect you and your customers.
          </p>
          
          <button
            type="submit"
            className="mt-6 px-6 py-3 bg-gradient-to-r from-emerald-500 to-blue-500 text-white rounded-full shadow-lg transform hover:scale-105 transition-transform duration-300"
          >
            Let's Connect
            <svg
              className="w-6 h-6 ml-2 inline-block transform group-hover:translate-x-1 transition-transform duration-300"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        <div className="col-span-2 mb-8 grid grid-cols-2 gap-8 lg:gap-12">
          {[
            { img: years, title: "10+", subtitle: "Years of Experience" },
            { img: machines, title: "1200+", subtitle: "Machines Installed" },
            { img: cuttingedge, title: "50+", subtitle: "Cutting Edge Technologies" },
            { img: happydoctors, title: "2000+", subtitle: "Happy Doctors" },
          ].map((card, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className="relative bg-blue-200 rounded-lg p-6 text-center shadow-lg transform hover:-translate-y-2 transition-transform duration-300 hover:shadow-2xl"
            >
              <div className="flex justify-center items-center h-16 w-16 rounded-full bg-blue-300 mx-auto mb-4 shadow-md">
                <img src={card.img} alt="" />
              </div>
              <h3 className="text-4xl font-semibold text-colorPrimary">{card.title}</h3>
              <p className="text-gray-800 font-medium">{card.subtitle}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ChooseUs;
